export default {
    ChangePassword: {
        Title: "Đổi mật khẩu",
        Password: "Mật khẩu hiện tại",
        NewPassword: "Mật khẩu mới",
        ConfirmPassword: "Xác nhận mật khẩu mới",
        ConfirmPasswordMismatch: "Xác nhận mật khẩu không khớp với mật khẩu mới",
        Success: "Đổi mật khẩu thành công",
    },
    UserLog: {
        Title: 'Nhật ký người dùng',
        SearchEmptyText: 'Tìm theo người dùng hoặc dữ liệu',
        Created: 'Thời gian',
        User: 'Người dùng',
        Action: 'Hành động',
        Data: 'Dữ liệu',
    },
    Title2FA: "Xác thực 2 yêu tố",
    MessNo2FA: "Tài khoản của bạn hiện chưa thực hiện kích hoạt 2FA. Bạn vui lòng kích hoạt để tăng bảo mật cho tài khoản của mình.",
    Add2FA: "Kích hoạt",
    Remove2FA: "Ngừng kích hoạt",
    MessHas2FA: "Tài khoản của bạn đã được thực hiện kích hoạt 2FA. Bạn có thể tắt chức năng bằng cách thực hiện chức năng ngừng kích hoạt.",
    Confirm2FA: "Xác nhận",
    Watchlist: {
        Title: 'Đối tượng theo dõi',
        SearchEmptyText: 'Tìm theo đối tượng',
        Created: 'Ngày tạo',
        Targets: 'Đối tượng',
        Description: 'Mô tả',
        Inactive: 'Ngừng theo dõi',
        Start: 'Áp dụng từ ngày',
        End: 'Áp dụng đến ngày',
        Action: 'Hành động',
    },
    Setting: {
        Title: "Thiết lập",
        Telegram: {
            Title: "Thông báo telegram",
            Token: "Token kết nối",
            Channel: "Mã kênh",
        }
    },
    Config: {
        Title: "Cấu hình",
        Enable: "Bật",
        Save: "Lưu",
        Cancel: "Hủy",
        DeviceAuto: {
            Title: "Quét tự động thiết bị",
            Index: "Vị trí CIDR hiện tại",
            LastValue: "CIDR xử lý gần nhất",
        },
        WebsiteAuto: {
            Title: "Quét tự động website",
            Index: "Vị trí hiện tại",
            LastValue: "Giá trị xử lý gần nhất",
        },
        Schedule: {
            Title: "Lịch chạy",
        },
        SplitTask: {
            Title: "Chia tác vụ",
        },
        AiSplit: {
            Title: "AI phân chia lệnh quét",
        },
        TimeLimit: {
            Title: "Giới hạn thời gian",
        },
        WideTask: {
            Title: "Tác vụ diện rộng",
        },
        Cluster: {
            Title: "Cụm quét chính",
        },
        Webhook: {
            Title: "Webhook MISP",
        },
        Normalize: {
            Title: "Chuẩn hóa thô",
        },
        Minio: {
            Title: "MinIO",
        },
        CollectMonitor: {
            Title: "Giám sát thu thập",
        },
        ScanTech: {
            Title: "Cấu hình WAF",
        },
        AdvancedScanner: {
            Title: "Advanced Scanner",
        },
        MissingFeatures: {
            Title: "Cấu hình nâng cao",
        }
    }
};  
